import { render } from "./NossosClientes.vue?vue&type=template&id=4ddde0fb"
import script from "./NossosClientes.vue?vue&type=script&lang=js"
export * from "./NossosClientes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__